module.exports = __webpack_public_path__ + "img/9fe6f37.png";